import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_PRODUCT_API_URL;

export const getVehicles = async ({
                                      makeId,
                                      modelId,
                                      variantId,
                                      yearId
                                  }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (makeId) searchParams.append("makeId", makeId);
        if (modelId) searchParams.append("modelId", modelId);
        if (variantId) searchParams.append("variantId", variantId);
        if (yearId) searchParams.append("yearId", yearId);
        searchParams.append("limit", 1);
        searchParams.append("skip", 0);

        const requestUrl = `?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data,
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const fetchVehicleDetails = async ({
                                              makeId,
                                              modelId,
                                              variantId,
                                              yearId,
                                              setVehicleToSave,
                                              setStatusInProgress,
                                              setStatusSuccess,
                                              setStatusFailed,
                                              setStatusError
                                          }) => {
    setStatusInProgress();
    try {
        if (!!makeId && !!modelId && !!variantId && !!yearId) {
            const response = await getVehicles({
                makeId,
                modelId,
                variantId,
                yearId
            });
            if (!!response?.success && response.data.length > 0) {
                setVehicleToSave(response.data[0]);
                setStatusSuccess();
            } else {
                setStatusFailed();
            }

        }
    } catch (e) {
        console.error(e);
        setStatusError();
    }
};

export const getMakes = async (yearId) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (yearId) searchParams.append("yearId", yearId);

        const requestUrl = `/makes?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getApplicationMakes = async ({
                                                      sku
                                                  }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const requestUrl = `/applications/makes/${sku}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else if (response.status === 401)
                    return {
                        error: true,
                        authError: true
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getModels = async (makeId, yearId) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (makeId) searchParams.append("makeId", makeId);
        if (yearId) searchParams.append("yearId", yearId);

        const requestUrl = `/models?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getApplicationModels = async ({
                                               sku,
                                               makeId
                                           }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (!!makeId) searchParams.append("makeId", makeId);

        const requestUrl = `/applications/models/${sku}?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else if (response.status === 401)
                    return {
                        error: true,
                        authError: true
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getVariants = async (makeId, modelId, yearId) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (makeId) searchParams.append("makeId", makeId);
        if (modelId) searchParams.append("modelId", modelId);
        if (yearId) searchParams.append("yearId", yearId);

        const requestUrl = `/variants?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getApplicationVariants = async ({
                                                 sku,
                                                 makeId,
                                                 modelId
                                             }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (!!makeId) searchParams.append("makeId", makeId);
        if (!!modelId) searchParams.append("modelId", modelId);

        const requestUrl = `/applications/variants/${sku}?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else if (response.status === 401)
                    return {
                        error: true,
                        authError: true
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getYears = async (makeId, modelId, variantId) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (makeId) searchParams.append("makeId", makeId);
        if (modelId) searchParams.append("modelId", modelId);
        if (variantId) searchParams.append("variantId", variantId);

        const requestUrl = `/years?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};

export const getApplicationYears = async ({
                                              sku,
                                              makeId,
                                              modelId,
                                              variantId
                                          }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/vehicle`, retry: true });

        const searchParams = new URLSearchParams();
        if (!!makeId) searchParams.append("makeId", makeId);
        if (!!modelId) searchParams.append("modelId", modelId);
        if (!!variantId) searchParams.append("variantId", variantId);

        const requestUrl = `/applications/years/${sku}?${searchParams.toString()}`;

        return await instance
            .get(requestUrl)
            .then((response) => {
                if (response.status === 200)
                    return {
                        error: false,
                        success: true,
                        message: response.data.message,
                        data: response.data.data
                    };
                else if (response.status === 401)
                    return {
                        error: true,
                        authError: true
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                } else if (error.request) {
                    console.error("Network Error:", error.request);
                } else {
                    console.error("Error:", error.message);
                }
            });
    } catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};
